import { Api } from "../config/request";

export default {
  getDlRcDetails(FeId) {
    return Api.get(`/dlrc/${FeId}`);
  },
  getDlRcAdditionalData(payload) {
    return Api.get("/dlrc/additional-data");
  },
  saveDlRcDetails(id, payload) {
    return Api.put(`/dlrc/${id}`, payload);
  },
  approveDlRcDetails(FeId, payload) {
    return Api.put(`/dlrc/${FeId}/dlrc-status`, payload);
  },
  updateDlRcField(FeId, payload) {
    return Api.put(`/dlrc/${FeId}/driver-detail`, payload);
  },
  updateEvQcDetails(payload) {
    return Api.post(`/dlrc/ev_qc`, payload);
  },
};
